import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { Grid2 } from "@mui/material";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import Logo from "/assets/images/logo-white.png";

const slides = [
  {
    image: "assets/newImages/carouselImg-1.png",
    textHeading: "You're only one click away from smart,",
    text: "well-analysed career choices",
  },
  {
    image: "assets/newImages/carouselimg2.png",
    textHeading: "Smart tech, Sharper insight,Powered by AI",
    text: null,
  },
];

const NonLoggedInLayout = ({ children, leftImage, leftImageAlt = "Login illustration" }) => {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box minHeight="100vh">
      <Grid2 container minHeight="100vh">

        {/* LEFT SIDE – FIXED */}
       
          <Grid2
            size={{ xs: 12, md: 5.5 }}
            sx={{
              backgroundColor: "#2E3367",
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Logo */}
            <Box sx={{ position: "absolute", top: "8%", left: "38%", mb: 2 }}>
              <img src={Logo} alt="logo" height={30} />
            </Box>


            {leftImage ? (
              <Box
                sx={{
                  width: "100%",
                  minHeight: { xs: 420, md: "100vh" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  px: { xs: 3, sm: 5, md: 6 },
                  pt: { xs: 10, md: 8 },
                }}
              >
                <Box
                  component="img"
                  src={leftImage}
                  alt={leftImageAlt}
                  sx={{
                    width: "100%",
                    maxWidth: { xs: 320, sm: 430, lg: 520 },
                    height: "auto",
                    display: "block",
                    objectFit: "contain",
                  }}
                />
              </Box>
            ) : (
              <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 10000 }}
                loop
                style={{ width: "100%", marginTop: "80px" }}
              >
                {slides.map((slide, index) => (
                  <SwiperSlide key={index}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        px: 6,
                      }}
                    >
                      {/* Circle Image */}
                      <Box
                        sx={{
                          width: "381px",
                          height: "404px",
                          borderRadius: "50%",
                          backgroundColor: "#F9A825",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 4,
                        }}
                      >
                        <img
                          src={slide.image}
                          alt="slide"
                          style={{ width: "100%" }}
                        />
                      </Box>

                      {/* Text */}
                      <Typography
                        fontSize="24px"
                        fontFamily={500}
                        sx={{
                          color: "#fff",
                          whiteSpace: "pre-line",
                          maxWidth: 360,
                        }}
                      >
                        {slide.textHeading}
                      </Typography>
                      <Typography
                      fontFamily={400}
                        fontSize={"20px"} sx={{
                          color: "#fff",
                          whiteSpace: "pre-line",
                          maxWidth: 360,
                        }}
                      >
                        {slide.text}
                      </Typography>
                    </Box>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </Grid2>
        

        {/* RIGHT SIDE – CHILDREN ONLY */}
        <Grid2
          size={{ xs: 12, md: 6.5 }}
          sx={{
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 4,
          }}
        >
          <Box sx={{ width: "100%", maxWidth: 420 }}>
            {children}
          </Box>
        </Grid2>

      </Grid2>
    </Box>
  );
};

export default NonLoggedInLayout;
